/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Status_LabelInputs */

const tr_geliver_tracking_status_label = /** @type {(inputs: Geliver_Tracking_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum`)
};

const en_geliver_tracking_status_label = /** @type {(inputs: Geliver_Tracking_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_geliver_tracking_status_label = /** @type {(inputs: Geliver_Tracking_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const ru_geliver_tracking_status_label = /** @type {(inputs: Geliver_Tracking_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Geliver_Tracking_Status_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_status_label = /** @type {((inputs?: Geliver_Tracking_Status_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Status_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_status_label(inputs)
	if (locale === "de") return de_geliver_tracking_status_label(inputs)
	if (locale === "ru") return ru_geliver_tracking_status_label(inputs)
	return tr_geliver_tracking_status_label(inputs)
});